import { isServerSide } from 'utils/isSSR';
import { BrowserStorageProvider } from './BrowserStorageProvider';
import { ServerSideAdapter } from './ServerSideAdapter';
import { LocalStorageAdapter } from './LocalStorageAdapter';

export const createBrowserStorage = () =>
  new BrowserStorageProvider(
    isServerSide() ? ServerSideAdapter : LocalStorageAdapter
  );
